import * as React from "react";
import DataImage from "../../DataImage";
import {IFoodBanksProps} from "../../utils/models";
import makeSum from "../../../../utils/makeSum";
import image from '../../asset/12. Vehicles.png'

const Vehicles = ({ submissions }: IFoodBanksProps) => {
    return (
        <DataImage
            image={image}
            value={makeSum(submissions, 'total_number_of_vehicles')}
            text="Total number of vehicles"
        />
    );
}

export default Vehicles;